// Хранилище загруженных игровых контроллеров вне Redux.
// Загрузчик сохраняет контроллер, сцена получает его через usePreloadedGameWrapper.
// Заменяет games.preloadGameWrapper, чтобы контроллер нельзя было достать из store.

const wrappers = new Map()
const listeners = new Set()

// Сохраняет загруженный контроллер и уведомляет сцены.
export function setPreloadedGameWrapper(game, wrapper) {
  wrappers.set(game, wrapper)
  listeners.forEach((notify) => notify())
}

// Очищает ссылки на контроллеры при входе в список игр.
export function clearPreloadedGameWrappers() {
  wrappers.clear()
  listeners.forEach((notify) => notify())
}

// Возвращает контроллер выбранной игры.
export function getPreloadedGameWrapper(game) {
  return wrappers.get(game) ?? null
}

// Подписывает сцену на загрузку контроллера; возвращает функцию отписки.
export function subscribePreloadedGames(notify) {
  listeners.add(notify)
  return () => listeners.delete(notify)
}
